// extracted by mini-css-extract-plugin
module.exports = {"header":"SubHeader3PL_header__k9f7H","title":"SubHeader3PL_title__1ShXn","small":"SubHeader3PL_small__zqCRy","btnContainer":"SubHeader3PL_btnContainer__L9AtG"};